export default __webpack_public_path__ + "./images/fo.3b4fb1d6.png";